export const payReserveEndPoint = '/reservation/pay-and-reserve';
export const payMoveInEndPoint = '/occupancy/pay-and-move-in';
